import {
    SET_CONVERSION_OVERVIEW,
    TOGGLE_CONVERSION_ACTIVITY_CLEAR,
    TOGGLE_CONVERSION_ACTIVITY_COMPLETE,
    TOGGLE_CONVERSION_ACTIVITY_FINAL,
    TOGGLE_CONVERSION_ACTIVITY_LATER,
    TOGGLE_CONVERSION_ACTIVITY_ONE_WEEK,
    TOGGLE_CONVERSION_ACTIVITY_PAST_DUE,
    TOGGLE_CONVERSION_ACTIVITY_TRIAL,
    SET_MODAL_CONVERSION,
} from '../ActionTypes';

const initActions = (services) => {
    const axiosCall = services.axios.Axios();

    const setModalConversion = (conversion) => {
        return {
            type: SET_MODAL_CONVERSION,
            payload: conversion,
        };
    };

    const updateMilestone = (milestoneId, type, fieldName, message = '') => {
        const typeLower = type.toLowerCase();
        return async (dispatch) => {
            try {
                const payload = { fieldName: fieldName, message: message };
                await axiosCall.patch(
                    `conversions/${typeLower}/${milestoneId}/update`,
                    payload
                );
            } catch (error) {
                throw error.message;
            }
        };
    };

    const updateMilestoneTarget = (milestoneId, type, targetDate, message) => {
        const typeLower = type.toLowerCase();
        return async (dispatch) => {
            try {
                const payload = {
                    fieldName: type,
                    targetDate: targetDate,
                    message: message,
                };
                await axiosCall.patch(
                    `conversions/${typeLower}/${milestoneId}/target`,
                    payload
                );
            } catch (error) {
                throw error.message;
            }
        };
    };

    const setConversionsOverview = (conversions) => {
        return {
            type: SET_CONVERSION_OVERVIEW,
            conversions: conversions,
        };
    };

    const fetchConversionOverview = () => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.get(`conversions/overview`);
                dispatch(setConversionsOverview(response.data.data));
                return response.data.data;
            } catch (error) {
                throw error.message;
            }
        };
    };

    const clearConversionActivityFilters = () => {
        return {
            type: TOGGLE_CONVERSION_ACTIVITY_CLEAR,
        };
    };

    const setTrialFilter = (status = false) => {
        return {
            type: TOGGLE_CONVERSION_ACTIVITY_TRIAL,
            status: status,
        };
    };

    const setFinalFilter = (status = false) => {
        return {
            type: TOGGLE_CONVERSION_ACTIVITY_FINAL,
            status: status,
        };
    };

    const setPastDueFilter = (status = false) => {
        return {
            type: TOGGLE_CONVERSION_ACTIVITY_PAST_DUE,
            status: status,
        };
    };

    const setOneWeekFilter = (status = false) => {
        return {
            type: TOGGLE_CONVERSION_ACTIVITY_ONE_WEEK,
            status: status,
        };
    };

    const setLaterFilter = (status = false) => {
        return {
            type: TOGGLE_CONVERSION_ACTIVITY_LATER,
            status: status,
        };
    };

    const setCompleteFilter = (status = false) => {
        return {
            type: TOGGLE_CONVERSION_ACTIVITY_COMPLETE,
            status: status,
        };
    };

    const updateConvertAttachments = ({ id, flag }) => {
        return async () => {
            try {
                await axiosCall.patch(`conversions/${id}/convertattachments`, {
                    convertAttachments: flag,
                });
            } catch (error) {
                throw error.message;
            }
        };
    };

    const updateSourcePims = ({
        conversionId: id,
        sourcePims,
        sourcePimsName,
    }) => {
        return async () => {
            try {
                await axiosCall.patch(`conversions/${id}/sourcepims`, {
                    sourcePims: sourcePims,
                    sourcePimsName: sourcePimsName,
                });
            } catch (error) {
                throw error.message;
            }
        };
    };

    const resetConversion = (conversionId) => {
        return async () => {
            try {
                await axiosCall.patch(`conversions/${conversionId}/reset`);
            } catch (error) {
                throw error.message;
            }
        };
    };

    const setTrialExpedited = (trialId, isExpedited, message) => {
        return async () => {
            try {
                await axiosCall.patch(
                    `conversions/trial/${trialId}/expedited`,
                    { isExpedited: isExpedited, message: message }
                );
            } catch (error) {
                throw error.message;
            }
        };
    };

    const setFinalExpedited = (finalId, isExpedited, message) => {
        return async () => {
            try {
                await axiosCall.patch(
                    `conversions/final/${finalId}/expedited`,
                    { isExpedited: isExpedited, message: message }
                );
            } catch (error) {
                throw error.message;
            }
        };
    };

    return {
        setModalConversion,
        clearConversionActivityFilters,
        fetchConversionOverview,
        resetConversion,
        setCompleteFilter,
        setFinalFilter,
        setLaterFilter,
        setOneWeekFilter,
        setPastDueFilter,
        setTrialFilter,
        updateMilestone,
        updateMilestoneTarget,
        updateConvertAttachments,
        updateSourcePims,
        setTrialExpedited,
        setFinalExpedited,
    };
};

export default initActions;
